/**
 * Hook para **marcar las alertas de salto como vistas**
 * (`POST /api/v1/talonarios/alertas/marcar_vistas`).
 *
 * Envuelve la llamada en un `useMutation`. Tras éxito invalida la query de
 * alertas para que el panel se refresque (vacío). El endpoint es de permiso
 * SILENCIOSO (sin `manage_talonarios` devuelve `{ok: true}`, no 403), así que es
 * inocuo invocarlo. La llamada va por `lib/api` (no `fetch` suelto).
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { getActiveSedeId } from "@/lib/sede";

import { talonarioAlertasQueryKey } from "./queryKeys";

interface MarkVistasResult {
  ok: boolean;
}

async function markAlertasVistas(): Promise<MarkVistasResult> {
  const response = await api.post("talonarios/alertas/marcar_vistas");
  return (await response.json()) as MarkVistasResult;
}

export function useMarkAlertasVistas() {
  const queryClient = useQueryClient();
  const sedeId = getActiveSedeId();
  return useMutation<MarkVistasResult, Error, void>({
    mutationFn: markAlertasVistas,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: talonarioAlertasQueryKey(sedeId),
      });
    },
  });
}
